var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    staticClass: "px-5 py-2",
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("List Expired Medical Check Up")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_vm.list && _vm.list.data && _vm.list.data.length ? _c('b-button', {
          staticClass: "mb-2",
          attrs: {
            "variant": "primary",
            "disabled": _vm.exporting
          },
          on: {
            "click": _vm.exportTable
          }
        }, [_vm.exporting ? _c('span', {
          staticClass: "spinner-border spinner-border-sm mr-2"
        }) : _c('i', {
          staticClass: "fa fa-file-excel mr-2"
        }), _vm._v(" Export ")]) : _vm._e(), _c('div', {
          staticClass: "d-flex w-100 align-items-center justify-content-between mb-4"
        }, [_c('b-form-input', {
          staticClass: "align-self-end w-50",
          attrs: {
            "placeholder": "Search name/NIP/document..."
          },
          on: {
            "keyup": function keyup($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onFilter.apply(null, arguments);
            }
          },
          model: {
            value: _vm.searchQuery,
            callback: function callback($$v) {
              _vm.searchQuery = $$v;
            },
            expression: "searchQuery"
          }
        }), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.onFilter.apply(null, arguments);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-filter"
        })])], 1)], 1), _vm.loading ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "alert alert-info m-4 align-items-center"
        }, [_c('span', {
          staticClass: "spinner-border spinner-border-sm mr-2"
        }), _vm._v(" Loading... ")])]) : _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_vm.list && _vm.list.data && _vm.list.data.length ? _c('div', {
          staticClass: "d-flex overflow-auto"
        }, [_c('table', {
          staticClass: "table table-bordered"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("NO")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Name")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Document")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Expired Date")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Notes")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l(_vm.list.data, function (mcu, index) {
          return _c('tr', {
            key: mcu.id || index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_vm.list.from || 1) + index))]), _c('td', [_vm.crewId(mcu) ? _c('router-link', {
            attrs: {
              "to": {
                path: 'profile',
                query: {
                  user: 'crew',
                  id: _vm.crewId(mcu)
                }
              }
            }
          }, [_vm._v(_vm._s(_vm.crew(mcu).fullname || '-'))]) : _c('span', [_vm._v(_vm._s(_vm.crew(mcu).fullname || '-'))]), _c('br'), _c('small', {
            staticClass: "text-muted"
          }, [_vm._v("NIP : "), _c('b', [_vm._v(_vm._s(_vm.crew(mcu).nip || '-'))])])], 1), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(mcu.nama_document || mcu.document_name || '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(" " + _vm._s(_vm.issuedAt(mcu)) + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.formatDate(mcu.date_expired || mcu.expired_date)))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(mcu.notes || mcu.remarks || '-'))]), _c('td', {
            staticClass: "text-center"
          }, [mcu.file_url ? _c('i', {
            staticClass: "fa fa-file-alt text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.openFile(mcu.file_url);
              }
            }
          }) : _c('span', [_vm._v("-")])])]);
        }), 0)])]) : _vm._e(), _vm.list && _vm.list.data && _vm.list.data.length ? _c('b-pagination', {
          staticClass: "mt-3",
          attrs: {
            "value": _vm.list.current_page,
            "total-rows": _vm.list.total,
            "per-page": _vm.list.per_page,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getListExpiredMCU
          }
        }) : _c('p', {
          staticClass: "text-center my-4"
        }, [_vm._v("List Expired MCU tidak ada.")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }